export const TestimonialsData = [
  {
    icon: 'CoinDCXLogo',
    title: 'Growth Marketer - Retention & Revenue, CoinDCX',
    name: 'Vansh Dingra',
    description: `It is always a joy to work with workbazaar, as all the timelines are met well in advance, never any compromise on quality.
    Above all the Consumer First approach makes workbazaar far better than anyone else in the similar business.`
  },
  {
    icon: 'PharmEasyLogo',
    name: 'Sahil Rana ',
    title: '',
    description: `Our association with workbazaar has been right since the launch of PharmEasy and they have been pioneers in assisting Pharmeasy in
    penetrating the PAN India market through various customer acquisition and retention activities.
    They are thoroughly professional and understand the exact requirements. All the best!`
  }
];
